import { RiDeleteBin5Fill } from "react-icons/ri";
import { BiEditAlt } from "react-icons/bi";
import {
  CanAccess,
  AuthorizationList,
} from "../../../components/template/authorization/Authorization";

export const initFilterInput = {
  search: "",
  page: 1,
  pageSize: 10,
};

export const statusItems = [
  { label: "Semua", value: "" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];

export const renderColumns = (handleEdit, handleDelete) => {
  return [
    {
      dataIndex: "name",
      key: "name",
      title: "Nama Juru Taksir",
    },
    {
      dataIndex: "phone_number",
      key: "phone_number",
      title: "No. Telepon",
      width: "20%",
    },
    {
      dataIndex: "status",
      key: "status",
      title: "Status",
    },
    {
      dataIndex: "action",
      key: "action",
      title: "Aksi",
      width: "10%",
      render: (_, record) => (
        <div style={{ textAlign: "center", display: "flex" }}>
          <CanAccess
            role={AuthorizationList.create_appraiser}
            yes={
              <div className="mr-2" onClick={() => handleEdit(record)}>
                <BiEditAlt
                  style={{
                    fontSize: 24,
                    color: "#F5CB58",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
          <CanAccess
            role={AuthorizationList.delete_appraiser}
            yes={
              <div className="mr-2" onClick={() => handleDelete(record)}>
                <RiDeleteBin5Fill
                  style={{
                    fontSize: 24,
                    color: "#F23434",
                    cursor: "pointer",
                  }}
                />
              </div>
            }
          />
        </div>
      ),
    },
  ];
};
